export default "__VITE_ASSET__B37JDxvj__";